import { render } from "./SignupConnect.vue?vue&type=template&id=7165fbda&lang=true"
import script from "./SignupConnect.vue?vue&type=script&lang=js"
export * from "./SignupConnect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__